import { isEqual } from 'lodash';

const getters = {
  equipmentFilter: (state) => {
    return state.equipmentFilter;
  },
  paginationQuery: (state) => {
    return state.paginationQuery;
  },
  searchQuery: (state) => {
    return state.searchQuery;
  },
  selected: (state) => {
    return state.selected;
  },
  isSelected: (state) => (id) => {
    return state.selected[id] !== undefined;
  },
  selectedLength: (state) => {
    return Object.keys(state.selected).length;
  },
  totalEquipment: (state) => {
    return state.totalEquipment;
  },
  areFiltersOrSearchApplied: (state) => {
    let keys = Object.keys(state.equipmentFilter);
    return (
      keys.length !== 0 ||
      (state.searchQuery !== '' && state.searchQuery !== null)
    );
  },
  totalFilteredEquipment: (state) => {
    return state.totalFilteredEquipment;
  },
  equipmentDetails: (state) => {
    return state.equipmentDetails;
  },
  cleanEquipmentDetails: (state) => {
    return state.cleanEquipmentDetails;
  },
  typeSchemas: (state) => {
    return state.typeSchemas;
  },
  hasExternalFilterDisplay: (state) => {
    return (
      state.equipmentFilter.externalFilterDisplay != null &&
      state.equipmentFilter.externalFilterDisplay.length >= 1
    );
  },
  isSelectedModified: (state) => {
    return !isEqual(
      Object.keys(state.selected).sort(),
      Object.keys(state.initialSelected).sort()
    );
  },
};

export { getters };
